import { bpsToPercent } from '~/domains/group/utils/groupShareMath';

export const formatSharePercent = (shareBps: number): string =>
  `${Math.round(bpsToPercent(shareBps))}%`;
